import { useState } from 'react';
import { Label, Error, Icon, ClassHelper } from 'components/lib';
import Style from './input.tailwind.js';
import { useTranslate } from 'app/translations.js';

export function NumberInput(props){
  const { _t } = useTranslate();
  const [error, setError] = useState(props.errorMessage || _t('number.empty'));

  function validate(e){

    const min = props.min;
    const max = props.max;
    let value = e ? e.target.value : '';
    let valid = undefined;

    // input is required and value is blank
    if (props.required && value === '')
      valid = false;

    // input isn't required and value is blank
    if (!props.required && value)
      valid = true;

    // now test for a valid number
    if (isNaN(value)){

      valid = false;
      setError(_t('number.invalid'));

    }

    // // check for min max
    if (min && max){
      if (value >= min && value <= max){
        valid = true;
      }
      else {
        valid = false;
        setError(_t('number.range', { min, max }));
      }
    }
    else if (min){
      if (value >= min){
        valid = true;
      }
      else {
        valid = false;
        setError(_t('number.equalOrAbove', { min }));
      }
    }
    else if (max){
      if (value <= max){
        valid = true;
      }
      else {
        valid = false;
        setError(_t('number.equalOrBelow', { max }));
      }
    }
    else {

      valid = true;

    }

    // update the parent form
    props.onChange?.(props.name, value, valid);

  }

  // style
  const numberStyle = ClassHelper(Style, {

    textbox: true, 
    className: props.className, 
    error: props.valid === false,
    success: props.valid === true,
    warning: props.warning,

  });

  return(
    <div className={ Style.input }>

      { props.label && 
        <Label
          text={ props.label }
          required={ props.required }
          for={ props.name }
        /> }

      {/* The check is positioned against this wrapper, not the whole
          block, so it stays centred on the control with or without a
          label. */}
      <div className={ Style.field }>

        <input
          type='number'
          id={ props.name }
          name={ props.name }
          className={ numberStyle }
          value={ props.value || '' }
          min={ props.min }
          max={ props.max }
          placeholder={ props.placeholder }
          onChange={ e => props.onChange?.(props.name, e.target.value, undefined) }
          onBlur={ e => validate(e) }
        />

        { props.valid === true &&
          <Icon
            image='check'
            color='currentColor'
            className={ Style.successIcon }
            size={ 16 }
          /> }

      </div>

      { props.valid === false &&
        <Error message={ error }/> }

      { props.hint &&
        <p className="text-xs text-text-muted">{ props.hint }</p> }

    </div>
  );
}
